module.exports = __webpack_public_path__ + "img/security_in_detail.ce912348.jpg";